import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import FuntoneBlockData from "../../../Models/Content/FuntoneBlockData";
import Funtone from "app/Components/Block/FuntoneBlock/Funtone";


export default class FuntoneBlock extends EpiComponent<FuntoneBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <Funtone context={this.getContext()} contentData={this.props.data} />;
  }
}
